'use strict';

angular.module('openDataApp')
  .directive('email', ['$q', '$timeout', 'ApiService', function ($q, $timeout, ApiService) {
    return {
      require: 'ngModel',
      restrict: 'A',
      link: function($scope, $elm, $attrs, $ctrl) {
        $ctrl.$asyncValidators.uniqueEmail = function(modelValue) {
          $scope.emailSuccess = false;
          if ($ctrl.$isEmpty(modelValue)) {
            return $q.when();
          }

          if ($scope.account !== undefined && $scope.account.email === modelValue) {
            return $q.when();
          }

          var def = $q.defer();
          ApiService.checkEmail(modelValue)
            .then(
              function success(response) {
                if (response.data) {
                  $scope.emailSuccess = true;
                  def.resolve();
                } else {
                  $scope.emailSuccess = false;
                  def.reject();
                }
              },
              function error() {
                $scope.emailSuccess = false;
                def.reject();
              }
            );

          return def.promise;
        };
      }
    };
  }]);
